import './TopBar.css';
import IconButton from './IconButton';


export default function TopBar({topHeader, onLeftClick, onRightClick}) {

    return (
        <div className="top-bar">
            {topHeader.leftIcon ? (
                <button className="top-bar-btn" onClick={onLeftClick}>
                    {IconButton[topHeader.leftIcon] || (<img src={`${process.env.PUBLIC_URL}${topHeader.leftIcon}`} alt="left" className={topHeader.leftIconRound ? 'top-bar-icon-round' : ''} />)}
                </button>
            ) : (
                <div className="top-bar-left"></div>
            )}
            <span className="top-bar-title">{topHeader.title}</span>
            {topHeader.rightIcon ? (
                <button className="top-bar-btn" onClick={onRightClick}>
                    {IconButton[topHeader.rightIcon] || (<img src={`${process.env.PUBLIC_URL}${topHeader.rightIcon}`} alt="right" className={topHeader.rightIconRound ? 'top-bar-icon-round' : ''} />)}                    
                </button>
            ) : (
                <div className="top-bar-right"></div>
            )}
        </div>
    )
}